import _ from 'lodash';
import ObjectClass from 'utils/objects/object'

export default class ObjectMessage {
	
	/**
	 * Filter inactive messages
	 * @param objects
	 * @returns {*[]}
	 */
	static filter = ( objects ) => {
		return ObjectClass.filterActive( objects );
	}
	
	/**
	 * Sort teh bookings by start
	 * @param objects
	 * @returns {objects[]}
	 */
	static order = ( objects ) => {
		return _.orderBy( objects, o => {
			return new Date( o.created_at );
		}, ['desc'] )
	}
	
	/**
	 * Filter and order
	 * @param objects
	 * @returns {objects[]}
	 */
	static filterAndOrder = ( objects ) => {
		return this.order( this.filter( objects ) );
	}
}
